module.exports = __webpack_public_path__ + "static/media/hero-private-lession.ed166ed9.jpg";